import { render, staticRenderFns } from "./ServiceTypeAdd.vue?vue&type=template&id=c462c0d2&scoped=true&"
import script from "./ServiceTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c462c0d2",
  null
  
)

export default component.exports